module.exports = __webpack_public_path__ + "static/media/psst_white.1d4e9bec.png";